export default __webpack_public_path__ + "static/media/version.3e2ef63c.txt";